import { AutomaticLogin } from "../../models/user/automatic-login.model";
import { CboModel } from "../../models/user/cbo.model"

export class AutomaticLoginStruct extends CboModel {
    
    public automaticLogin: AutomaticLogin;
    public lastSession: string;
}